export default __webpack_public_path__ + "static/GT-America-Mono-Regular-fec8aa3a2e38fabc8c2b62c7062f51f8.woff2";